// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .no-header {
   background-color: #ffffff;
}

.file-share {
   background-color: #fff;
   border: 1px solid #ccc;
   border-radius: 3px;
   cursor: pointer;
   display: none;
   line-height: 22px;
   outline: none;
   position: relative;
   margin-left: 10px;
   min-width: 40px;
   padding: 0 10px;
   text-align: center;
}
.file-share { padding: 0 16px; }
.file-delete { margin-right: 10px; }
.doclist li:hover .file-share, .doclist li:hover .file-restore, .doclist li:hover .file-delete {
   display: block;
}
.owner {
   margin-top: 12px;
   display: flex;
   height: 30px;
   min-width: 112px;
}

::ng-deep .fullname {
   flex: 1;
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
}

.toolbar {
   align-items: center;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.breadcrumb1 {
   line-height: 30px;
   overflow: hidden;
   white-space: nowrap;
}

.mat-form-field {
   font-size: 14px;
   width: 100%;
}

.mat-column-select {
   overflow: visible;
}

.firstSampleAnimation {
   padding: 20px;
}

.firstSampleAnimation.ng-hide-add,
.firstSampleAnimation.ng-hide-remove {
   /*-webkit-transition : 1s ease-in-out opacity;
   -moz-transition    : 1s ease-in-out opacity;
   -ms-transition     : 1s ease-in-out opacity;
   -o-transition      : 1s ease-in-out opacity;
   transition         : 1s ease-in-out opacity;*/
   opacity: 1;
}

.firstSampleAnimation.ng-hide {
   z-index: 1;
   opacity: 0;
}

.app-list {
   margin: 50px 20px 20px;
   position: relative;
   transition: background-color .3s, opacity .3s;
}

.search-box {
   padding-left: 1em;
   position: relative;
}

.loading-shade {
   position: absolute;
   top: 0;
   left: 0;
   bottom: 56px;
   right: 0;
   background: rgba(0, 0, 0, 0.15);
   z-index: 1;
   display: flex;
   align-items: center;
   justify-content: center;
}

.rate-limit-reached {
   color: #980000;
   max-width: 360px;
   text-align: center;
}

mat-select{
   width: 40% !important;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

#btn_DelContact {
   margin-right: 10px;
}

.mat-column-select {
   width: 2%;
   text-align: center;
}


.mat-column-no {
   width: 5%;
   text-align: center;
}

.mat-column-fullName {
   width: 75%;
}

.mat-column-type {
   width: 20%;
}

.mat-column-members {
   width: 10%;
   text-align: center;
}

.mat-column-permission {
   width: 40%;
}

.mat-column-menu {
   width: 10%;
   text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/group-company/group-company.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;AAC5B;;AAEA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,iBAAiB;GACjB,aAAa;GACb,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,eAAe;GACf,kBAAkB;AACrB;AACA,cAAc,eAAe,EAAE;AAC/B,eAAe,kBAAkB,EAAE;AACnC;GACG,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB,aAAa;GACb,YAAY;GACZ,gBAAgB;AACnB;;AAEA;GACG,OAAO;GACP,uBAAuB;GACvB,mBAAmB;GACnB,gBAAgB;AACnB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,WAAW;AACd;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,aAAa;AAChB;;AAEA;;GAEG;;;;gDAI6C;GAC7C,UAAU;AACb;;AAEA;GACG,UAAU;GACV,UAAU;AACb;;AAEA;GACG,sBAAsB;GACtB,kBAAkB;GAClB,6CAA6C;AAChD;;AAEA;GACG,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,YAAY;GACZ,QAAQ;GACR,+BAA+B;GAC/B,UAAU;GACV,aAAa;GACb,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,cAAc;GACd,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,SAAS;GACT,kBAAkB;AACrB;;;AAGA;GACG,SAAS;GACT,kBAAkB;AACrB;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,UAAU;GACV,kBAAkB;AACrB;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,UAAU;GACV,iBAAiB;AACpB","sourcesContent":["::ng-deep .no-header {\n   background-color: #ffffff;\n}\n\n.file-share {\n   background-color: #fff;\n   border: 1px solid #ccc;\n   border-radius: 3px;\n   cursor: pointer;\n   display: none;\n   line-height: 22px;\n   outline: none;\n   position: relative;\n   margin-left: 10px;\n   min-width: 40px;\n   padding: 0 10px;\n   text-align: center;\n}\n.file-share { padding: 0 16px; }\n.file-delete { margin-right: 10px; }\n.doclist li:hover .file-share, .doclist li:hover .file-restore, .doclist li:hover .file-delete {\n   display: block;\n}\n.owner {\n   margin-top: 12px;\n   display: flex;\n   height: 30px;\n   min-width: 112px;\n}\n\n::ng-deep .fullname {\n   flex: 1;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   overflow: hidden;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.breadcrumb1 {\n   line-height: 30px;\n   overflow: hidden;\n   white-space: nowrap;\n}\n\n.mat-form-field {\n   font-size: 14px;\n   width: 100%;\n}\n\n.mat-column-select {\n   overflow: visible;\n}\n\n.firstSampleAnimation {\n   padding: 20px;\n}\n\n.firstSampleAnimation.ng-hide-add,\n.firstSampleAnimation.ng-hide-remove {\n   /*-webkit-transition : 1s ease-in-out opacity;\n   -moz-transition    : 1s ease-in-out opacity;\n   -ms-transition     : 1s ease-in-out opacity;\n   -o-transition      : 1s ease-in-out opacity;\n   transition         : 1s ease-in-out opacity;*/\n   opacity: 1;\n}\n\n.firstSampleAnimation.ng-hide {\n   z-index: 1;\n   opacity: 0;\n}\n\n.app-list {\n   margin: 50px 20px 20px;\n   position: relative;\n   transition: background-color .3s, opacity .3s;\n}\n\n.search-box {\n   padding-left: 1em;\n   position: relative;\n}\n\n.loading-shade {\n   position: absolute;\n   top: 0;\n   left: 0;\n   bottom: 56px;\n   right: 0;\n   background: rgba(0, 0, 0, 0.15);\n   z-index: 1;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n}\n\n.rate-limit-reached {\n   color: #980000;\n   max-width: 360px;\n   text-align: center;\n}\n\nmat-select{\n   width: 40% !important;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n#btn_DelContact {\n   margin-right: 10px;\n}\n\n.mat-column-select {\n   width: 2%;\n   text-align: center;\n}\n\n\n.mat-column-no {\n   width: 5%;\n   text-align: center;\n}\n\n.mat-column-fullName {\n   width: 75%;\n}\n\n.mat-column-type {\n   width: 20%;\n}\n\n.mat-column-members {\n   width: 10%;\n   text-align: center;\n}\n\n.mat-column-permission {\n   width: 40%;\n}\n\n.mat-column-menu {\n   width: 10%;\n   text-align: right;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
